/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Event_Trigger_Ask_AdminInputs */



/**
* | output |
* | --- |
* | "Ask an administrator to connect {connector}." |
*
* @param {Agent_Event_Trigger_Ask_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_ask_admin = /** @type {((inputs: Agent_Event_Trigger_Ask_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Ask_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitten Sie eine Administratorin oder einen Administrator, ${i?.connector} zu verbinden.`)
	return /** @type {LocalizedString} */ (`Ask an administrator to connect ${i?.connector}.`)
});